import React, { FormEvent, useState } from "react";
import { AiOutlineSearch } from "react-icons/ai";
import { MdArrowForward } from "react-icons/md";
import { Button, Input, Spinner } from "reactstrap";

import classes from "@/styles/carriers/carrier-details.module.css";
import { carrierDetails } from "@/utils/content";
import { useIsMobile } from "@/hooks/useIsMobile";
import useGoogleAnalytics from "@/hooks/useGoogleAnalytics";
import useAlertBar from "@/hooks/useAlertBar";
import { getTrackingDetails } from "@/services/track-shipment";

type Props = {
  carrierContent: {
    subTitle: string;
    desc: string;
  };
};

const listOfCarriers = [
  {
    label: "UPS",
    value: "ups",
  },
];

const TrackingWidget = ({ carrierContent }: Props) => {
  const content = carrierDetails.en;
  const isMobile = useIsMobile();

  const [shippingCarrier] = useState(listOfCarriers[0].value);
  const [trackingNumber, setTrackingNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [trackingDetails, setTrackingDetails] = useState("");

  const { sendCustomEvent } = useGoogleAnalytics();
  const { openAlertBar } = useAlertBar();

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);

    sendCustomEvent("trackShipment", {
      page: {
        url:
          document.location.origin +
          document.location.pathname +
          document.location.search,
      },
      params: { trackingNumber, shippingCarrier },
    });
    try {
      const { data } = await getTrackingDetails({
        trackingNumber,
        shippingCarrier,
      });

      if (data?.status) {
        let details = `
                ${shippingCarrier.toUpperCase()}
                Tracking No: ${trackingNumber}
    
                ============ Track Events ==============

                `;
        data.data.events.forEach(
          (e: any) =>
            (details += `
                    Date & Time: ${e.date}
                    Location: ${e.location}
                    Description: ${e.description}
                `)
        );

        setTrackingDetails(details);
      } else {
        openAlertBar(data.message, false);
      }
    } catch (error) {
      console.log(error);
      openAlertBar(`Unexpected error occurred: ${error}`, false);
    }

    setLoading(false);
  };

  return (
    <div className="my-4">
      <h2 className={classes.title2}>{carrierContent.subTitle}</h2>
      <p className={`w-50 mx-auto ${classes.para2}`}>{carrierContent.desc}</p>
      <form onSubmit={handleSubmit}>
        <h4 className="mt-5">
          {content.trackingNumber} <AiOutlineSearch />
        </h4>
        <Input
          className={`${isMobile ? "" : "w-25"} mx-auto mt-3 mb-3`}
          type="search"
          name="track"
          onChange={(e) => setTrackingNumber(e.target.value)}
        />
        {trackingDetails && (
          <div className={`${classes.detailsSection} my-3`}>
            <label htmlFor="details">Tracking Details</label>
            <textarea
              className={`form-control ${isMobile ? "" : "w-75"} mx-auto`}
              value={trackingDetails}
              readOnly
              id="details"
            />
          </div>
        )}
        <Button type="submit" disabled={loading} className={classes.btn}>
          {content.btnText}&nbsp;
          {loading ? (
            <Spinner size="sm" className="ms-4" />
          ) : (
            <MdArrowForward size={18} />
          )}
        </Button>
      </form>
    </div>
  );
};

export default TrackingWidget;
